"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * @author Adam Drda
 */


var Ingredient =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(Ingredient, _DomainObject_1$Domai);

  /**
   * @param externalId
   * @param productId
   * @param amount amount needed for recipe
   */
  function Ingredient(externalId, productId, amount) {
    var _this;

    _classCallCheck(this, Ingredient);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Ingredient).call(this));
    _this.externalId = externalId;
    _this.productId = productId;
    _this.amount = amount;
    return _this;
  }

  return Ingredient;
}(DomainObject_1.DomainObject);

exports.Ingredient = Ingredient;

Ingredient.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(Ingredient.name);
  return {
    externalId: builder.str('externalId'),
    productId: builder.str('productId'),
    amount: builder.num('amount')
  };
}();